<template>
  <div>
    <instSystemScreenDescription>
      <template v-slot:icon>
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:id="'loader25'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 32a4 4 0 110 8 4 4 0 010-8zM9.482 26a5 5 0 110 10 5 5 0 010-10zm23.156 1a4 4 0 110 8 4 4 0 010-8zM37 18.638a3 3 0 110 6 3 3 0 010-6zM5 12a5 5 0 110 10 5 5 0 010-10zm30.572-1.586a2 2 0 110 4 2 2 0 010-4zM16 0a6 6 0 110 12 6 6 0 010-12zm15 6a1 1 0 110 2 1 1 0 010-2z" fill="#3DAE2B"/></svg>
      </template>
      <template v-slot:title>
        <h3>Заявка на рассмотрении</h3>
      </template>
      <template v-slot:description>
        <p>{{loaderDescription[currentTextIndex]}}</p>
      </template>
    </instSystemScreenDescription>
  </div>
</template>

<script>
export default {
  name: "instSaveDemand",
  data(){
    return {
      loaderDescription:[
        'Делаем запрос в Бюро Кредитных Историй',
        'Проверяем кредитную историю',
        'Осуществляем скоринговую проверку',
        'Определяем доступный лимит',
        'Подбираем персонального менеджера',
        'Подготавливаем документы',
        'Создаем личный кабинет',
      ],
      currentTextIndex:0,
    }
  },
  components:{
    instSystemScreenDescription: ()=> import('@/components/inst/instSystemScreenDescription.vue')
  },
  async mounted() {
    console.log('mounted instSaveDemand')
    window.loaderDemand = setInterval(()=>{
      console.log('interval' + window.loaderDemand)
      if (this.currentTextIndex < this.loaderDescription.length - 1) {
        this.currentTextIndex +=1;
      } else {
        this.currentTextIndex = 0;
      }
    }, 3000);

    const demandId = await this.$store.dispatch('instSaveDemand');
    // const demandId = 738828;
    const designDemand = await this.$store.dispatch('instChekDesignDemand',{
      demand: demandId,
      iteration: 0
    });

    if (designDemand.type === 'registration') {
      console.log('designDemand.data')
      console.log(designDemand.data)
      localStorage.setItem('GUIDeasyConf',designDemand.data);
      this.$store.dispatch('inst_trySetSystemScreen', 'instLoaderGetDemandState');
      this.$router.push(`/reg?r=${designDemand.data}`);
      // const demandState = await this.$store.dispatch('instGetDemandState', {iteration: 0 });
      // if(demandState.demandState >= 0) {
      //   this.$store.dispatch('inst_trySetSystemScreen', 'instSaveDemand');
      //   this.$router.push(`/reg?r=${designDemand.data}`);
      // } else {
      //   if (window.canRedirect === 1) {
      //     this.$palantir.trackAction(128, window.linkToMarket);
      //     document.location.href = window.linkToMarket;
      //   } else {
      //     this.$store.dispatch('inst_trySetSystemScreen', 'instRejectTime')
      //   }
      // }
    }
  },
  beforeDestroy() {
    clearInterval(window.loaderDemand)
    console.log('destroy');
  }
}
</script>

<style scoped>
#loader25{
  animation: 3s linear infinite rotate;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>